import { accountState } from '@/app/model/store/domain/types.ts'

export default <accountState> {
  accountData: [],
  allFieldData: [],
  choiceAccountType: 0,
  searchText: '',
  sortName: 'name',
  sortAsc: true
}
